import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { EProductType } from '@leedpulse-monorepo/enums';

export interface AddSubscriptionToCompanyPayload {
  company_id: string;
  items: Array<{ plan_id: string }>;
  user_uid?: string;
  user_phone?: string;
}

interface AddSubscriptionToCompanyResponse {
  created_subscriptions: string[];
}

async function addSubscriptionToCompany(
  payload: AddSubscriptionToCompanyPayload,
  auth: Authentication
): Promise<AddSubscriptionToCompanyResponse> {
  try {
    const response = await HttpClient.post(
      `/${EProductType.LEEDFLOW}/stripe/subscription/add-numbers`,
      payload,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('addSubscriptionToCompany error:', e);
    throw new AddSubscriptionToCompanyFailure(e.message);
  }
}

export class AddSubscriptionToCompanyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default addSubscriptionToCompany;
